export * from './MaskOverlay';
export * from './types';

export const maskRoute =
  '/:entityType/:entityId/details/:subEntityType/:subEntityId/';
